import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	feedbackSuccessFlagDescription: {
		id: 'platform.feedback.feedback-collector.feedback-renderer.success-flag.feedback-success-flag-description',
		defaultMessage: 'Your valuable feedback helps us continually improve our products.',
		description: 'Description shown when feedback is successfully submitted',
	},
	feedbackSuccessFlagTitle: {
		id: 'platform.feedback.feedback-collector.feedback-renderer.success-flag.feedback-success-flag-title',
		defaultMessage: 'Thanks!',
		description: 'Button to dismiss success flag flag after submitting feedback',
	},
	feedbackSuccessFlagDescriptionAppify: {
		id: 'platform.feedback.feedback-collector.feedback-renderer.success-flag.feedback-success-flag-description-appify',
		defaultMessage: 'Your valuable feedback helps us continually improve our apps.',
		description: 'Description shown when feedback is successfully submitted',
	},
});
